import { AxiosResponse } from 'axios';
import { useMutation } from 'react-query';

// configs
import { API } from 'configs/api';
// utils
import { getShortUrlFromUrl } from 'utils/url';

export const updateViewMutation = async () => {
  const shortUrl = getShortUrlFromUrl();
  if (!shortUrl) {
    throw new Error('Invalid url');
  }

  const response: AxiosResponse = await API.patch(`/playback/${shortUrl}/view`);

  return response.data;
};

export const useUpdateViewMutation = () => {
  return useMutation(updateViewMutation);
};
